module.exports = __webpack_public_path__ + "img/lostTime.eee282a2.svg";